import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import type { AdTouchpointSourceType } from '@trello/ad-sequencer';
import { useLazyComponent } from '@trello/use-lazy-component';

interface LazyDiscoveryAdCreateBoardContainerProps {
  source: AdTouchpointSourceType;
  workspaceId?: string;
}

export const LazyDiscoveryAdCreateBoardContainer: FunctionComponent<
  LazyDiscoveryAdCreateBoardContainerProps
> = (props) => {
  const DiscoveryAdCreateBoardContainer = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "discovery-ad-create-board-container" */ './DiscoveryAdCreateBoardContainer'
      ),
    { namedImport: 'DiscoveryAdCreateBoardContainer' },
  );

  return (
    <Suspense fallback={null}>
      <DiscoveryAdCreateBoardContainer {...props} />
    </Suspense>
  );
};
